import Vue from 'vue'
const permission={
    inserted(el, value, vnode) {
	   var code=value.expression
       var permissions=localStorage.getItem('buttonIds')
       if(permissions==null||permissions==""||permissions==undefined){
       	el.parentNode && el.parentNode.removeChild(el)
       }
       var codeall=(JSON.parse(permissions))
		if(!(codeall.includes(code))){
			el.parentNode && el.parentNode.removeChild(el)
		}
    }
}

Vue.directive('permission', permission)